<template>

  <div class="bigpalette-container">
    <header>
      <router-link class="go-back" to="/">
        <span>←</span>Back</router-link>
      <CopyFormat/>
      <a href="javascript:;" class="toggle-sound" @click="toggleSound">
        <span v-if="soundOn">Sound On 🔊</span>
        <span v-if="!soundOn">Sound Off 🔇</span>
      </a>
    </header>
    <div class="colors">
      <div class="color" v-for="color in palette.colors" :style="{background:color.hex}" @mouseover="changeCopiedText(color.hex)" @click="copy(color.hex)" v-clipboard:copy="copiedText">
        <a href="javascript:;"></a>
        <span>{{color.name}}</span>
      </div>
    </div>
    <div class="copied" :class="{'show-copied' : showCopied}" :style="{backgroundColor : copiedBgColor}">
      <div :class="{animateIn : copyAnimation, animateOut : !copyAnimation}">{{copiedMessage}}
        <span>{{copiedText}}</span>
      </div>
    </div>
    <footer>
      <a v-if="false" @click="onSponsorClick" :href="bottomData.link" class="left" target="_blank">
        <img class="bottomData-img" height="25" src="~@/assets/shutterstock-mini-logo.png" alt=""> {{bottomData.descr}}
      </a>
      <a :href="paletteInfo.url" target="_blank" class="author" @click="$ga.event('profile-click', paletteInfo.dribbble);">
        {{paletteInfo.name}} by {{paletteInfo.from}}
        <span v-if="paletteInfo.id != 'defo'">from</span>
        <span class="emoji" v-if="paletteInfo.id != 'defo'">{{paletteInfo.emoji}}</span>
      </a>
    </footer>
  </div>
</template>

<script>
let palettes = require(`@/data/palettes.json`);
import CopyFormat from "@/components/CopyFormat";
import { mapState } from "vuex";
import { sendActivity } from '@/api';

export default {
  name: "BigPalette",
  components: {
    CopyFormat
  },
  computed: {
    ...mapState(["format"])
  },
  data() {
    return {
      palette: {},
      palettes,
      paletteInfo: {},
      copyAnimation: false,
      showCopied: false,
      copiedBgColor: "#fff",
      copiedText: "",
      soundOn: true,
      copiedMessage: 'COPIED!',
      bottomData: {},
      bottomDataArray: [
        {
          key: "p-ss-0",
          descr: "Find eye catching visual at Shutterstock",
          link: "https://bit.ly/3fszxY3"
        },
        {
          key: "p-ss-1",
          descr: "Explore professional stock photos at Shutterstock. Thousands added daily.",
          link: "https://bit.ly/3fszxY3"
        }
      ]
    };
  },
  beforeMount() {
    this.paletteInfo = _.find(this.palettes, { id: this.$route.params.id });
    this.bottomData = _.sample(this.bottomDataArray);
    this.palette = require(`@/data/palette-${this.$route.params.id}.json`);
    $crisp.push(["do", "chat:hide"]);

    if (localStorage.getItem("soundOn") === null) {
      localStorage.setItem("soundOn", true);
    }

    this.soundOn = JSON.parse(localStorage.getItem("soundOn"));
  },
  mounted() {
    sendActivity('FUIC_PALETTE_AD_SHOW', this.bottomData.key);
  },
  metaInfo() {
    return {
      title: this.paletteInfo.emoji + " " + this.paletteInfo.name
    };
  },
  methods: {
    beforeEnter() {
      console.log("BeforeEnter");
    },
    toggleSound() {
      this.soundOn = !this.soundOn;
      this.$ga.event("sound-toggle", this.soundOn);
      localStorage.setItem("soundOn", this.soundOn);
    },
    onSponsorClick() {
      sendActivity('FUIC_PALETTE_AD_CLICK', this.bottomData.key);
    },
    changeCopiedText(color){
      this.copiedText = this.colorWithFormat(color);
    },
    copy(color) {
      let messages = ['COPIED!', 'GOT IT!', 'PASTE ME!', 'IT\'LL ROCK!', 'RIGHT ONE!', 'WILL DO!'];
      this.copiedMessage = messages[Math.floor(Math.random() * messages.length)];
      if (this.soundOn) {
        window.sounds.copiedSound.currentTime = 0;
        setTimeout(() => {
          window.sounds.copiedSound.play();
        }, 300);
      }
      const that = this;
      // that.$copyText(that.copiedText);
      that.copiedBgColor = color;
      that.showCopied = true;
      that.copyAnimation = true;
      setTimeout(() => {
        that.copyAnimation = false;
      }, 600);
      setTimeout(() => {
        that.showCopied = false;
      }, 1000);
    },
    colorWithFormat(color) {
      if (this.format === "hex") return color;
      else if (this.format === "hex2") return color.substring(1);
      else if (this.format === "rgb") return this.hexToRgb(color);
      else if (this.format === "rgba") {
        let code = this.hexToRgb(color);
        code = code.replace("rgb", "rgba").substring(0, code.length);
        code += ",1.0)";
        return code;
      }
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? `rgb(${parseInt(result[1], 16)}, ${parseInt(
            result[2],
            16
          )}, ${parseInt(result[3], 16)})`
        : null;
    }
  }
};
</script>
<style lang="scss" scoped>
.bigpalette-container {
  position: fixed;
  width: calc(100vw);
  height: 100%;
  font-weight: 600;
  overflow: hidden;
  a {
    color: #000;
  }
  $height: 50px;
  header,
  footer {
    position: absolute;
    width: 100%;
    background: #fff;
    height: $height;
    line-height: $height - 5px;
    padding: 0px 20px;
    box-sizing: border-box;
    .bottomData-img{
      position: relative;
      right: 3px;
      top:6px;
    }
  }
  header {
    top: 0px;
    .toggle-sound {
      float: right;
      transition: all 0.2s;
      &:active {
        transform: scale(0.97);
      }
    }
    .go-back {
      float: left;
      transition: all 0.2s;
      &:active {
        transform: scale(0.97);
      }
      span {
        font-weight: bold;
        margin-right: 7px;
      }
    }
  }
  footer {
    bottom: 0px;
    height: 0px;
    .author {
      float: right;
      .emoji {
        font-size: 20px;
        position: relative;
        top: 3px;
      }
    }
  }
  .colors {
    position: absolute;
    background: red;
    width: 100%;
    height: calc(100% - (80px));
    top: $height;
    .color {
      width: 20%;
      float: left;
      height: 25%;
      background: green;
      position: relative;
      cursor: pointer;
      a {
        display: inline-block;
        width: 100px;
        height: 40px;
        display: inline-block;
        text-align: center;
        line-height: 45px;
        color: #000;
        //             background: #fff;
        color: #fff !important;
        border-radius: 5px;
        border: 2px solid rgba(255, 255, 255, 0.2);

        //             border-left: none;
        //             border-right: none;
        //             border-top: none;
        -webkit-filter: sepia(1);
        -webkit-perspective: 1000;
        -webkit-backface-visibility: hidden;
        -webkit-transform: translate3d(0, 0, 0);
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -50px;
        margin-top: -22.5px;
        opacity: 0;
        transition: transform 0.2s, opacity 0.3s;
        pointer-events: none;
        user-select: none;
        background-image: url("~@/assets/copy.svg");
        background-repeat: no-repeat;
        background-position: center center;
      }
      span{
        position: absolute;
        bottom: 8px;
        color: #fff;
        opacity: 0.9;
        text-transform: uppercase;
        right: 8px;
      }
      &:hover a {
        opacity: 1;
      }
      &:active a {
        transform: scale(0.94);
      }
    }
  }
  .copied {
    position: fixed;
    width: 140%;
    height: 100%;
    text-align: center;
    z-index: 200;
    top: 0px;
    left: -20%;
    background: #3498db;
    transition: opacity 0.4s;
    opacity: 0;
    pointer-events: none;
    &.show-copied {
      opacity: 1;
      pointer-events: all;
    }
    div {
      font-size: 120px;
      height: 120px;
      line-height: 110px;
      color: #ecf0f1;
      top: 50%;
      margin-top: -120px;
      text-shadow: 2px 2px #2c3e50;
      background: rgba(255, 255, 255, 0.2);
      padding: 30px 0;
      position: absolute;
      width: 100%;
      user-select: none;
    }
    span {
      top: 50%;
      text-shadow: 1px 1px #444;
      height: 60px;
      margin-top: 120px;
      position: absolute;
      color: #ecf0f1;
      display: block;
      width: 100%;
      font-size: 32px;

    }
  }
}

@media (max-width: 1024px) {
  .bigpalette-container{
    .colors{
      .color{
        span{
          display: none;
        }
      }
    }
  }
}

.copied div.animateIn {
  -webkit-animation: copiedKeyFrames 0.4s ease !important;
  -moz-animation: copiedKeyFrames 0.4s ease !important;
  -ms-animation: copiedKeyFrames 0.4s ease !important;
  -o-animation: copiedKeyFrames 0.4s ease !important;
  animation: copiedKeyFrames 0.4s ease !important;
  -webkit-animation-fill-mode: forwards;
  /*Chrome 16+, Safari 4+*/

  -moz-animation-fill-mode: forwards;
  /*FF 5+*/

  -o-animation-fill-mode: forwards;
  /*Not implemented yet*/

  -ms-animation-fill-mode: forwards;
  /*IE 10+*/

  animation-fill-mode: forwards;
  /*when the spec is finished*/
}
.copied div.animateOut {
  -webkit-animation: copiedKeyFramesOut 0.4s ease !important;
  -moz-animation: copiedKeyFramesOut 0.4s ease !important;
  -ms-animation: copiedKeyFramesOut 0.4s ease !important;
  -o-animation: copiedKeyFramesOut 0.4s ease !important;
  animation: copiedKeyFramesOut 0.4s ease !important;
  -webkit-animation-fill-mode: forwards !important;
  /*Chrome 16+, Safari 4+*/

  -moz-animation-fill-mode: forwards;
  /*FF 5+*/

  -o-animation-fill-mode: forwards;
  /*Not implemented yet*/

  -ms-animation-fill-mode: forwards;
  /*IE 10+*/

  animation-fill-mode: forwards;
  /*when the spec is finished*/
}
@-webkit-keyframes copiedKeyFramesOut {
  0% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.8);
    opacity: 0;
  }
}
@-moz-keyframes copiedKeyFramesOut {
  0% {
    -moz-transform: scale(1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes copiedKeyFramesOut {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}
@-webkit-keyframes copiedKeyFrames {
  0% {
    -webkit-transform: scale(1.2);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 1;
  }
}
@-moz-keyframes copiedKeyFrames {
  0% {
    -moz-transform: scale(1.2);
    opacity: 0;
  }
  100% {
    -moz-transform: scale(1);
    opacity: 1;
  }
}
@keyframes copiedKeyFrames {
  0% {
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BigPalette.vue